import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import config from '../../config';
import classNames from 'classnames';
import { Modal, Icon } from '../../components';

import css from './PointsModal.module.css';
import { propTypes } from '../../util/types';

const PointsModal = props => {
  const {
    className,
    rootClassName,
    id,
    currentUser,
    points,
    isOpen,
    onCloseModal,
    onManageDisableScrolling,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  const userTiers = config.userTiers;

  const currentUserPoints = currentUser?.attributes?.profile?.metadata?.points || 0;
  const currentUserTotalPoints = currentUserPoints + points;

  // Convert tiers object to array and sort by min points
  const tiersArray = Object.values(userTiers).sort((a, b) => a.min - b.min);

  // Find current tier
  const currentTier = tiersArray.find(
    tier => currentUserTotalPoints >= tier.min && currentUserTotalPoints <= tier.max
  );

  // Find next tier
  const currentTierIndex = tiersArray.findIndex(tier => tier.id === currentTier?.id);
  const nextTier =
    currentTierIndex !== -1 && currentTierIndex < tiersArray.length - 1
      ? tiersArray[currentTierIndex + 1]
      : null;

  // Capitalize first letter of tier id
  const capitalizeFirst = str => str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <Icon name="celebrate" size={48} className={css.modalIcon} />
      <p className={css.modalTitle}>
        {nextTier ? (
          <FormattedMessage
            id="PointsModal.titleWithNextTier"
            values={{
              points: <span className={css.highlighted}>{points}</span>,
              tierName: <span className={css.highlighted}>{capitalizeFirst(nextTier.id)}</span>,
              tierPoints: <span className={css.highlighted}>{nextTier.min}</span>,
            }}
          />
        ) : (
          <FormattedMessage
            id="PointsModal.titleMaxTier"
            values={{ points: <span className={css.highlighted}>{points}</span> }}
          />
        )}
      </p>
    </Modal>
  );
};

const { string, number } = PropTypes;

PointsModal.defaultProps = {
  className: null,
  rootClassName: null,
  currentUser: null,
  points: 0,
};

PointsModal.propTypes = {
  className: string,
  rootClassName: string,
  currentUser: propTypes.currentUser,
  points: number,
};

export default injectIntl(PointsModal);
